// extracted by mini-css-extract-plugin
export var numpadContainer = "_rs-1";
export var phoneButton = "_rs-0";